<div class="atividade-checklist mb-3">
    <div class="atividade-checklist-body">
        <sgt-collapse-group title="Checklist" [isCollapsedInDefault]="true" #collapseGroup>
            <div class="atividade-checklist-item"
                *ngFor="let entity of entities; let i = index"
                [class.atividade-checklist-item-concluido]="entity.concluido">

                <div class="atividade-checklist-item-body">
                    <div class="atividade-checklist-item-checkbox">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.concluido" name="checkboxItemConcluido_{{i}}" id="checkboxItemConcluido_{{i}}"
                                (ngModelChange)="onChangeConcluido(entity)">
                            <label class="custom-control-label" for="checkboxItemConcluido_{{i}}"></label>
                        </div>
                    </div>
                    <div class="atividade-checklist-item-content">
                        <textarea class="form-control" [(ngModel)]="entity.nome" name="checkboxItemNome_{{i}}" id="checkboxItemNome_{{i}}"
                            #nome="ngModel" #textareaNome rows="1" sgtAutosize [disabled]="!canEdit(entity)" [readOnly]="!canEdit(entity)"
                            (blur)="onBlurNome(entity, i)">
                        </textarea>

                        <div class="atividade-checklist-item-options" *ngIf="hasOptions(entity)">
                            <div class="btn-group">
                                <button type="button" class="btn btn-link" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" tabindex="-1">
                                    <i class="fas fa-ellipsis-h"></i>
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item dropdown-item-delete" *ngIf="canDelete(entity)"  (click)="delete(entity, i)">
                                        <i class="far fa-trash-alt"></i> Excluir
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="atividade-checklist-item-footer">

                </div> -->
            </div>
            <div class="atividade-checklist-item no-entities" *ngIf="!entities || entities.length === 0">
                <p class="form-text text-muted">
                    <i class="fas fa-info"></i> Nenhum item adicionado ao checklist
                </p>
            </div>
        </sgt-collapse-group>
    </div>
    <div class="atividade-checklist-footer">
        <div class="atividade-checklist-footer-options">
            <button type="button" class="btn btn-light btn-sm" *ngIf="canInsert()" (click)="insert()">
                <i class="fas fa-plus"></i> Adicionar Item
            </button>
        </div>
        <div class="atividade-checklist-footer-progress">
            <div class="atividade-checklist-footer-progress-percent" title="Percentual concluído">
                {{(percQuantidadeChecklistItensConcluidos ? percQuantidadeChecklistItensConcluidos : 0) | decimalFormat: 1:0:0}}%
            </div>
            <div class="atividade-checklist-footer-progress-bar">
                <div class="progress">
                    <div class="progress-bar" role="progressbar" [style.width]="percQuantidadeChecklistItensConcluidos + '%'" [attr.aria-valuenow]="percQuantidadeChecklistItensConcluidos" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </div>
            <div class="atividade-checklist-footer-progress-counter">
                <span title="{{(quantidadeChecklistItensConcluidos ? quantidadeChecklistItensConcluidos : 0) | decimalFormat: 1:0:0}} item(ns) concluído(s)">{{(quantidadeChecklistItensConcluidos ? quantidadeChecklistItensConcluidos : 0) | decimalFormat: 1:0:0}}</span>
                <span>/</span>
                <span title="{{(quantidadeChecklistItens ? quantidadeChecklistItens : 0) | decimalFormat: 1:0:0}} item(ns) no checklist">{{(quantidadeChecklistItens ? quantidadeChecklistItens : 0) | decimalFormat: 1:0:0}}</span>
            </div>
        </div>
    </div>
</div>
